/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";
import { lazy } from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { PlayerProps } from "./types";

export default CustomPlatform.select<() => React.FC<PlayerProps>>({
  web: () => lazy(() => import("./Player")),
  default: () => require("./Player").default,
})();
